import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BadgeRequest } from '../../models/badge/badge-request';
import { BadgeModel } from '../../models/badge/badge-model';
import { AppConfig } from '../config.service';
import { WorkInfoOperationChangedModel } from '../../models/work-info/work-info-operation-changed.model';
import { Observable } from 'rxjs';
import { WorkInfoOrderChangedModel } from '../../models/work-info/work-info-order-changed.model';
import { WorkInfoCostCenterChangedModel } from '../../models/work-info/work-info-cost-center-changed.model';
import { WorkInfoAbsenceChangedModel } from '../../models/work-info/work-info-absence-changed.model';
import {
  BadgeAbsenceRequest,
  ManualGehenTime,
} from '../../models/client-models';

const BADGE_ENDPOINT = 'badge';

@Injectable({
  providedIn: 'root',
})
export class BadgeBackendService {
  constructor(private http: HttpClient) {}

  getCurrentState(badgeRequest: BadgeRequest): Observable<BadgeModel> {
    return this.http.get<BadgeModel>(
      AppConfig.settings.backend.url +
        BADGE_ENDPOINT +
        '?idPerson=' +
        badgeRequest.idPerson
    );
  }

  comeAndGo(badgeRequest: BadgeRequest): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT,
      badgeRequest.idPerson
    );
  }

  goWithTime(goWithTime: ManualGehenTime): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/goWithTime',
      goWithTime
    );
  }

  comeAndGoAbsence(badgeRequest: BadgeAbsenceRequest): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/absence',
      badgeRequest
    );
  }

  /**
   * Send request to backend when person selects new order to work on.
   *
   * @param newOrder infos about the new order.
   */
  orderChange(newOrder: WorkInfoOrderChangedModel): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/orderChange',
      newOrder
    );
  }

  /**
   * Send request to backend when person selects new cost center to work.
   *
   * @param newCostCenter infos about cost center.
   */
  costCenterChange(
    newCostCenter: WorkInfoCostCenterChangedModel
  ): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/costCenterChange',
      newCostCenter
    );
  }

  /**
   * Send request to backend when person selects new operation to work on.
   *
   * @param newOperation infos about operation.
   */
  operationChange(
    newOperation: WorkInfoOperationChangedModel
  ): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/operationChange',
      newOperation
    );
  }

  /**
   * Send request to backend when person selects new absence as work info.
   *
   * @param newAbsence infos about absence.
   */
  absenceChange(
    newAbsence: WorkInfoAbsenceChangedModel
  ): Observable<BadgeModel> {
    return this.http.post<BadgeModel>(
      AppConfig.settings.backend.url + BADGE_ENDPOINT + '/absenceChange',
      newAbsence
    );
  }
}
